// extracted by mini-css-extract-plugin
export default {"swiperNextButton":"NavigationButtons_swiperNextButton__O6sGo","swiperPrevButton":"NavigationButtons_swiperPrevButton__gTMAk"};